import { Link } from "react-router-dom";

import styles from './products.module.css';

export const Product = ({ product }) => {
    function refreshPage() {
        window.location.reload(true);
    }
    return (
        <div className="col-lg-3 col-md-6 col-sm-12 masonry-item small-column all shutters curtains blinds home_drcor">
            <div className="project-block-one">
                <div className="inner-box">
                    <figure className="image-box">
                        <img src={`/images/gallery/gallery-${product.pic}.jpg`} />
                    </figure>
                    <div className="content-box">
                        {/* <div className="view-btn"><Link to={`/Products/Details/${product.model}`}>+</Link></div> */}

                        <h3 className={styles.h3}><Link to={`/Products/Details/${product.model}`}>{product.title}</Link></h3>
                        <div className="text">
                            <ul>
                                <li onClick={refreshPage}><Link to={`/Catalogs/Prices/${product.model}`}>Цени</Link></li>
                                <li>/</li>
                                <li onClick={refreshPage}><Link to="/Calculator">Калкулатор</Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};